import { Link } from 'react-router-dom';
import { COMPANY } from '@/data/site';
import { Phone, Mail, MapPin } from 'lucide-react';
import { AlphaTexMark } from '@/components/brand/AlphaTexLogo';

export default function Footer() {
  return (
    <footer className="relative bg-white border-t border-black/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <AlphaTexMark className="w-14 h-16" />
            <div className="leading-[0.95]">
              <div className="font-display uppercase tracking-tight text-2xl text-[#0A0A0A]">
                ALPHA TEX
              </div>
              <div className="font-mono-label text-[10px] tracking-[0.28em] uppercase text-[#0A0A0A]/55 mt-1 flex items-center gap-1.5">
                <span>Construction · Remodel</span>
                <span className="w-1 h-1 rounded-full bg-[#DC2626]" />
                <span className="text-[#1D4ED8]">Est. 2023</span>
              </div>
            </div>
          </div>
          <p className="mt-6 text-[#0A0A0A]/70 max-w-md leading-relaxed">
            A residential and commercial construction studio building calm, high-quality spaces across the {COMPANY.serviceArea}.
          </p>
          <div className="mt-8 flex flex-wrap gap-2 font-mono-label text-[10px] tracking-[0.22em] uppercase text-[#0A0A0A]/65">
            <span className="px-3 py-1.5 border border-black/10">Licensed</span>
            <span className="px-3 py-1.5 border border-black/10">Insured</span>
            <span className="px-3 py-1.5 border border-black/10">Bonded</span>
            <span className="px-3 py-1.5 border border-black/10">EPA Lead-Safe</span>
            <span className="px-3 py-1.5 border border-[#DC2626]/60 text-[#DC2626]">Se Habla Español</span>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono-label text-[10px] tracking-[0.24em] uppercase text-[#1D4ED8] mb-4">Explore</div>
          <ul className="space-y-3 text-[#0A0A0A]/80">
            <li><Link to="/" className="hover:text-[#1D4ED8]">Home</Link></li>
            <li><Link to="/services" className="hover:text-[#1D4ED8]">Services</Link></li>
            <li><Link to="/projects" className="hover:text-[#1D4ED8]">Projects</Link></li>
            <li><Link to="/about" className="hover:text-[#1D4ED8]">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#1D4ED8]">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono-label text-[10px] tracking-[0.24em] uppercase text-[#1D4ED8] mb-4">Get in touch</div>
          <ul className="space-y-3 text-[#0A0A0A]/80">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-1 text-[#DC2626]" />
              <div className="flex flex-col leading-tight">
                <a href={COMPANY.phoneHref} className="hover:text-[#1D4ED8]">{COMPANY.phone}</a>
                <a href={COMPANY.phoneAltHref} className="hover:text-[#1D4ED8] text-[#0A0A0A]/60 text-sm mt-0.5">Direct · {COMPANY.phoneAlt}</a>
              </div>
            </li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-1 text-[#DC2626]" /><a href={COMPANY.emailHref} className="hover:text-[#1D4ED8] break-all">{COMPANY.email}</a></li>
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-1 text-[#DC2626]" /><span>{COMPANY.serviceArea}</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-black/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-[#0A0A0A]/45 font-mono-label text-[10px] tracking-[0.22em] uppercase">
          <div>© {new Date().getFullYear()} Alpha Tex · All rights reserved</div>
          <div>Built for people who care about details</div>
        </div>
      </div>
    </footer>
  );
}
